import { IAppState } from '../../redux';
import { selectIsDraftOffer, selectIsNewOffer } from '../offer';

export function selectIsSaveDraftButtonAvailable(state: IAppState): boolean {
  const isNewOffer = selectIsNewOffer(state);
  const isDraftOffer = selectIsDraftOffer(state);

  return isNewOffer || isDraftOffer;
}
